import { useCore } from '../../feature/context/core.context';
import { Locale } from '../../util/locales/locale.model';
import { convertLocaleStringToLocaleObject } from '../../util/locales/locales';

export const useUserLocale = (): Locale | undefined => {
  const {
    auth: { user },
  } = useCore();

  return user?.locale ? convertLocaleStringToLocaleObject(user.locale) : undefined;
};
